"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _component = _interopRequireDefault(require("../component.js"));

var _button = _interopRequireDefault(require("../button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*---------------------------------------------*/
var METADATA = {
  name: 'ButtonGroup',
  description: 'Todo',
  props: [{
    name: 'type',
    type: 'string',
    description: 'Choose which type of tabs component to display',
    options: [{
      value: 'basic',
      description: 'basic'
    }, {
      value: 'minimal',
      description: 'minimal'
    }]
  }, {
    name: 'selected',
    type: 'string',
    description: 'Set selected tab',
    options: [{
      value: '1',
      description: '1'
    }, {
      value: '2',
      description: '2'
    }, {
      value: '3',
      description: '3'
    }]
  }],
  demo: {}
};
/*---------------------------------------------*/

var ButtonGroup = /*#__PURE__*/function (_Component) {
  _inherits(ButtonGroup, _Component);

  var _super = _createSuper(ButtonGroup);

  function ButtonGroup() {
    var _this;

    _classCallCheck(this, ButtonGroup);

    _this = _super.call(this);
    _this.state = {
      index: 0
    };
    _this.onButtonClick = _this.onButtonClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ButtonGroup, [{
    key: "onButtonClick",
    value: function onButtonClick(index, e) {
      this.setState({
        index: index
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var baseClassName = 'lth-c-buttongroup';

      var buttons = _react.default.Children.map(this.props.children, function (child, index) {
        var position = 'inner';
        if (index === 0) position = 'first';else if (index === _this2.props.children.length - 1) position = 'last';
        var props = {
          ingroup: true,
          position: position,
          onClick: function onClick(e) {
            return _this2.onButtonClick(index, e);
          }
        };
        if (index === _this2.state.index) props.pressed = true;
        return /*#__PURE__*/_react.default.cloneElement(child, props);
      });

      return /*#__PURE__*/_react.default.createElement("div", {
        style: this.getStyle(),
        className: baseClassName
      }, buttons);
    }
  }]);

  return ButtonGroup;
}(_component.default);
/*---------------------------------------------*/


exports.default = ButtonGroup;

_defineProperty(ButtonGroup, "METADATA", METADATA);

METADATA.demo.content = [/*#__PURE__*/_react.default.createElement(_button.default, {
  key: 1
}, "Option 1"), /*#__PURE__*/_react.default.createElement(_button.default, {
  key: 2
}, "Option 2"), /*#__PURE__*/_react.default.createElement(_button.default, {
  key: 3
}, "Option 3")];
/*---------------------------------------------*/